'use client';

import { Loader } from '@components/Loader';

import { TaskManagement } from '@app/features/TaskManagement/TaskManagement';

import { useGetTaskList } from '@api/generator';

export default function TaskManagementPage() {
  const { data, isLoading: isTaskListLoading, isError: isTaskListError } = useGetTaskList();

  if (isTaskListLoading) {
    return <Loader testId="taskLoader" />;
  }

  return <TaskManagement tasks={data?.data || []} isApiError={isTaskListError} />;
}
